import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonos = [{
    id: '01',
    title: 'Scripts de Afirmaciones Vibracionales',
    value: '$12.000'
  }, {
    id: '02',
    title: 'Guía de Instrumentos Caseros',
    value: '$12.000'
  }, {
    id: '03',
    title: 'Diario de Resonancia (Plantillas imprimibles)',
    value: '$10.000'
  }, {
    id: '04',
    title: 'Protocolo Niños en Calma',
    value: '$15.000'
  }, {
    id: '05',
    title: 'Diccionario de Frecuencias Hz',
    value: '$12.000'
  }, {
    id: '06',
    title: 'Playlist Master Index',
    value: '$10.000'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-6xl mx-auto" data-id="element-28">
      <FadeIn data-id="element-29">
        <div className="text-center mb-6 md:mb-14" data-id="element-30">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-[#7c3aed]/10 mb-3 md:mb-6 border border-[#7c3aed]/20" data-id="element-31">
            <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(124,58,237,0.4)]" data-id="element-32">
              🎁
            </span>
          </div>
          <h2 className="text-2xl md:text-5xl font-black px-2 text-[#1f1b16]" data-id="element-33">
            LOS 6 BONOS — SIEMPRE INCLUIDOS
          </h2>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-6 md:mb-12" data-id="element-34">
        {bonos.map((bono, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-35">
            <motion.div whileHover={{
          scale: 1.02
        }} className="bg-[#faf7f2] border border-[#e7dfce] hover:border-[#7c3aed]/50 rounded-2xl p-4 md:p-6 flex items-start gap-3 md:gap-5 relative overflow-hidden group h-full shadow-sm hover:shadow-md transition-all" data-id="element-36">
              <div className="absolute -right-6 -top-6 text-7xl md:text-9xl font-black text-[#f5efe4] group-hover:text-[#7c3aed]/10 transition-colors pointer-events-none" data-id="element-37">
                {bono.id}
              </div>

              <div className="bg-[#7c3aed]/10 p-2 md:p-3 rounded-xl border border-[#7c3aed]/20 shrink-0 relative z-10" data-id="element-38">
                <Gift className="text-[#7c3aed] w-5 h-5 md:w-7 md:h-7" data-id="element-39" />
              </div>

              <div className="relative z-10 flex-grow" data-id="element-40">
                <h3 className="text-sm md:text-lg font-bold text-[#1f1b16] mb-2 md:mb-3 leading-snug pr-6 md:pr-8" data-id="element-41">
                  {bono.title}
                </h3>
                <div className="flex items-center gap-2 md:gap-3" data-id="element-42">
                  <span className="bg-[#7c3aed] text-[#0f0d09] text-[10px] md:text-xs font-black px-2 py-0.5 md:py-1 rounded uppercase tracking-wider" data-id="element-43">
                    GRATIS
                  </span>
                  <span className="text-[#ef4444] line-through text-xs md:text-sm font-bold" data-id="element-44">
                    {bono.value}
                  </span>
                </div>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-45">
        <div className="max-w-2xl mx-auto relative group" data-id="element-46">
          <div className="absolute inset-0 bg-[#7c3aed]/20 blur-xl rounded-full group-hover:bg-[#7c3aed]/30 transition-all duration-500" data-id="element-47"></div>
          <div className="relative bg-[#0f0d09] border-2 border-[#7c3aed]/50 rounded-2xl p-4 md:p-8 text-center shadow-[0_10px_30px_rgba(124,58,237,0.2)]" data-id="element-48">
            <p className="text-base md:text-3xl font-black text-white flex flex-col md:flex-row items-center justify-center gap-1.5 md:gap-4" data-id="element-49">
              <span data-id="element-50">Valor total bonos:</span>
              <span className="text-[#ef4444] line-through decoration-[#ef4444]/50 decoration-4" data-id="element-51">
                $71.000
              </span>
              <span className="text-[#7c3aed] drop-shadow-[0_0_10px_rgba(124,58,237,0.5)]" data-id="element-52">
                → GRATIS
              </span>
            </p>
            <p className="text-xs md:text-base text-[#a78bfa] mt-1.5 md:mt-2 font-bold" data-id="element-53">
              Incluidos hoy con tu Botiquín Vibracional Pro
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}